export const maxInputWidth: string = "26rem";


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/sizes.ts